<modal (closeOut)="onClose()" height="90%">
  <modal-header><span>{{title}}</span></modal-header>
  <modal-body>
    <ti-renderer [component]="component" [updater]="updater"></ti-renderer>
  </modal-body>
  <modal-actions>
    <button kendoButton fillMode="solid" themeColor="tertiary" (click)="onClose()">{{miscStrings.cancel}}</button>
  </modal-actions>
</modal>
